import styled from "styled-components";

import { QUERIES, SPACING } from "../../../utils/constants";
import { SelectPill } from "../../../components/MobileForm/styles";

export const FullWidthSelectPill = styled(SelectPill)`
  width: 100%;
`;

export const ResponsiveRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: ${SPACING.md}px;

  @media ${QUERIES.tabletLargeAndUp} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

export const UnitField = styled.div`
  position: relative;
  width: 100%;
`;

export const UnitSuffix = styled.span`
  position: absolute;
  top: 1px;
  right: 0;
  display: flex;
  align-items: center;
  height: calc(0.875rem * 1.2 + 1rem);
  padding-right: ${SPACING.sm + SPACING.xs}px;
  font-size: var(--text-base);
  color: var(--color-text-secondary);
  pointer-events: none;
`;

export const PanelNote = styled.p<{ $tone: "warning" | "muted" }>`
  display: flex;
  align-items: flex-start;
  gap: ${SPACING.sm}px;
  margin: 0;
  font-size: var(--text-sm);
  font-style: italic;
  line-height: 1.4;
  color: ${({ $tone }) =>
    $tone === "warning"
      ? "var(--color-warning)"
      : "var(--color-text-secondary)"};

  & > svg {
    flex-shrink: 0;
    font-size: var(--text-md);
    margin-top: ${SPACING.xxs}px;
  }
`;
